export default __webpack_public_path__ + "static/media/Path1223@2x.b07b91df.png";